type ChartAxisTickProps = {
  x: number;
  y: number;
  dy: number;
  payload: { value: string };
  textAnchor?: 'start' | 'end';
};

export const ChartYAxisTick = ({ x, y, payload, textAnchor = 'end' }: ChartAxisTickProps) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={4}
        textAnchor={textAnchor}
        fill="rgb(var(--colors-base-text-quaternary) / var(--tw-text-opacity))"
        className="text-caption-xss-a"
      >
        {payload.value}
      </text>
    </g>
  );
};
